import * as React from 'react';
import t from 'utils/translate';
import InformationDialog from 'modules/shared/components/information-dialog';
import { useSelector } from 'react-redux';
import { resetCacheClearWarning, selectCacheClearWarning } from '../../settings/stores/company-settings-slice-handler';

function CacheClearWarning() {
    const shouldShowWarning = useSelector(selectCacheClearWarning);

    if (!shouldShowWarning) {
        return '';
    }

    return (
        <InformationDialog
            infoMessage={t('js_all_cache_clear_warning')}
            closeCallback={() => resetCacheClearWarning()}
        />
    );
}

export default CacheClearWarning;
